import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress, Typography} from '@mui/material';

interface I18nProviderProps {
  children: React.ReactNode;
}

/**
 * I18nProvider component that ensures translations are loaded before rendering children.
 * This prevents missing key errors caused by components rendering before i18next
 * has finished loading translation files.
 */
export const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  const { ready } = useTranslation();

  if (!ready) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          gap: 2,
        }}
      >
        <CircularProgress size={40} />
        <Typography variant="body2" color="text.secondary">
          Loading translations...
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
};

export default I18nProvider;
